module.exports = __webpack_public_path__ + "static/img/20016 (4).18aca0a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20016 (4).webp
// module id = 52yf
// module chunks = 14